import {
  fetchWardrobe,
  addToWardrobe,
  removeFromWardrobe,
} from "../lib/wardrobeApi";

export async function getWardrobeItems() {
  return fetchWardrobe();
}

export async function addWardrobeItem(item) {
  await addToWardrobe(item);
  return item;
}

export async function removeWardrobeItem(id) {
  return removeFromWardrobe(id);
}